<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input-number ttRememberId="w_custactcalcadjustdisc.cost_pst_add" ttLabel="cost_pst_add" [(ttModel)]="edit.cost_pst_add" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-button-save ttText="custactcalcadjustdisc_save" (ttClick)="executeChanges()" [ttLoading]="executing"></tt-button-save>
    </tt-card>
</tt-page>
